module.exports = __webpack_public_path__ + "img/rajesh-smc.b5c5dd1b.jpg";